(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(pointer: fine)');
  const motion = () => document.body.dataset.motion !== 'false' && !reduce.matches;
  const boot = (root = document) => {
    root.querySelectorAll('[data-tilt]').forEach(stage => {
      if (stage.dataset.bound) return;
      stage.dataset.bound = 'true';
      let frame = 0;
      stage.addEventListener('pointermove', event => {
        if (!motion() || !fine.matches || event.pointerType === 'touch') return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const rect = stage.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          stage.style.setProperty('--rx', `${-y * 6}deg`);
          stage.style.setProperty('--ry', `${x * 7}deg`);
          stage.style.setProperty('--mx', `${x * 10}px`);
          stage.style.setProperty('--my', `${y * 10}px`);
        });
      });
      const reset = () => {
        cancelAnimationFrame(frame);
        ['--rx', '--ry', '--mx', '--my'].forEach(prop => stage.style.removeProperty(prop));
      };
      stage.addEventListener('pointerleave', reset);
      reduce.addEventListener('change', reset);
    });
    root.querySelectorAll('.nn-hotspot').forEach(hotspot => {
      if (hotspot.dataset.bound) return;
      hotspot.dataset.bound = 'true';
      hotspot.addEventListener('toggle', () => {
        if (hotspot.open) hotspot.parentElement.querySelectorAll('.nn-hotspot').forEach(other => { if (other !== hotspot) other.open = false; });
      });
    });
    if (motion() && 'IntersectionObserver' in window && !document.body.classList.contains('nn-design-mode')) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08 });
      root.querySelectorAll('[data-reveal]:not(.is-observed)').forEach(el => { el.classList.add('is-observed'); observer.observe(el); });
    }
  };
  document.addEventListener('pointerdown', event => {
    const button = event.target.closest('.nn-button');
    if (!button || !motion() || button.disabled) return;
    const rect = button.getBoundingClientRect();
    const pulse = document.createElement('span');
    pulse.className = 'nn-ripple';
    pulse.setAttribute('aria-hidden', 'true');
    pulse.style.left = `${event.clientX - rect.left}px`;
    pulse.style.top = `${event.clientY - rect.top}px`;
    button.appendChild(pulse);
    setTimeout(() => pulse.remove(), 700);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nn-hotspot[open], .nn-mobile-menu[open], .nn-nav-dropdown[open]').forEach(details => {
      if (details.contains(document.activeElement)) details.querySelector('summary').focus();
      details.open = false;
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.nn-mobile-menu[open], .nn-nav-dropdown[open]').forEach(details => {
      if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
  boot();
})();
